import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dinh-muc-index-cell" }
const _hoisted_2 = { class: "dinh-muc-index-cell__order" }
const _hoisted_3 = { class: "dinh-muc-index-cell__id" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Số văn bản", -1)
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Cấp S/C", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Nhóm toa xe", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "S/lg vật tư", -1)
const _hoisted_10 = { class: "mb-0 text-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Ban hành", -1)
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Hiệu lực", -1)
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Hết hiệu lực", -1)
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = {
  key: 0,
  class: "el-tag el-tag--success text-black el-tag--medium fw-bold rounded-none d-block w-100"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Ghi chú", -1)
const _hoisted_19 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}

import BaseLink from "@/components/shared/base-link/BaseLink.vue";
import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import { withListPage } from "@/core/helpers/list-page-context";
import { swalErrNotification, swalNotification } from "@/core/helpers/utils";
import { useDateTime } from "@/core/hooks/use-date-time-hook";
import { useLoading } from "@/core/hooks/use-loading";
import { usePagination } from "@/core/hooks/use-pagination";
import { IDinhMucCoDinhNewResponseBase } from "@/core/interfaces/ApiResponses";
import { DinhMucCoDinhService } from "@/core/services/DinhMucCoDinh.service";
import IconEye from "@/icons/IconEye.vue";
import IconPencil from "@/icons/IconPencil.vue";
import IconTrash from "@/icons/IconTrash.vue";
import moment from "moment/moment";
import { PropType } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'DinhMucCoDinhTable',
  props: {
  curPage: {
    type: Number,
    default: 0,
  },
  items: {
    type: Array as PropType<IDinhMucCoDinhNewResponseBase[]>,
    required: true,
  },
  perPage: {
    type: Number,
    default: 0,
  },
  /** When set (update page), highlight the row for the item being edited */
  selectedId: {
    type: Number,
    default: 0,
  },
  showCapSuaChua: {
    type: Boolean,
    default: true,
  },
  showSoLuongVatTu: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const { indexCal } = usePagination();

const { formatDisplayingDate } = useDateTime();

const { push } = useRouter();

const { startLoading, endLoading } = useLoading();

const store = useStore();

const rowClassName = ({
  row,
}: {
  row: IDinhMucCoDinhNewResponseBase;
}): string => {
  if (props.selectedId > 0 && row.id === props.selectedId) {
    return "current-row";
  }

  return "";
};

// Expired date validation function
const isExpired = (ngayHetHan: string | Date | null): boolean => {
  if (!ngayHetHan) {
    return false; // No expiry date means unlimited
  }

  const today = moment();
  const expiryDate = moment(ngayHetHan);

  return today.isAfter(expiryDate, "day");
};

const onDeleteButtonClick = (row: IDinhMucCoDinhNewResponseBase) => {
  store.commit("ConfirmationDialogModule/setDialog", {
    message: `Bạn có chắc chắn muốn xoá định mức cố định ID ${row.id}?`,
    onConfirm: async () => {
      store.commit("ConfirmationDialogModule/closeDialog");
      await startLoading();

      try {
        await DinhMucCoDinhService.delete(row.id);
        await endLoading();
        await swalNotification("Xoá định mức cố định thành công");

        await push({
          name: "danh-sach-dinh-muc-co-dinh",
        });
      } catch (e) {
        await endLoading();
        await swalErrNotification(e, "Không thể xoá định mức cố định này");
      }
    },
  });
};

const getSettingActions = (
  row: IDinhMucCoDinhNewResponseBase
): SettingAction[] => {
  const isRowExpired = isExpired(row.ngay_het_han);

  return [
    {
      icon: IconEye,
      label: "Chi tiết",
      tooltip: "Chi tiết",
      onClick: () =>
        push({
          path: `/quan-ly/dinh-muc-co-dinh/chi-tiet/${row.id}`,
        }),
    },
    {
      icon: IconPencil,
      label: "Chỉnh sửa",
      isDisabled: isRowExpired,
      tooltip: isRowExpired
        ? "Không thể chỉnh sửa định mức cố định đã hết hạn"
        : "Chỉnh sửa",
      any: ["master:dinhmuccodinh:sua"],
      onClick: () => {
        const path = `/quan-ly/dinh-muc-co-dinh/chinh-sua/${row.id}`;

        if (props.selectedId > 0 && row.id === props.selectedId) {
          // Already editing this row — scroll to form instead of a no-op push
          window.scrollTo({ top: 0, behavior: "smooth" });
          return;
        }

        void push(withListPage(path, props.curPage));
      },
    },
    {
      icon: IconTrash,
      label: "Xoá",
      any: ["master:dinhmuccodinh:xoa"],
      onClick: () => onDeleteButtonClick(row),
    },
  ];
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    border: true,
    "empty-text": "Không có dữ liệu",
    data: __props.items,
    "row-class-name": rowClassName,
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "STT",
        width: "70"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(indexCal)(scope.$index, __props.curPage, __props.perPage)), 1),
            _createElementVNode("span", _hoisted_3, " (" + _toDisplayString(scope.row.id) + ") ", 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "150" }, {
        header: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_5, _toDisplayString(scope.row.so_bien_ban || scope.row.so_van_ban || "-"), 1)
        ]),
        _: 1
      }),
      (__props.showCapSuaChua)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            width: "300"
          }, {
            header: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx((scope) => [
              (scope.row.cap_sua_chua)
                ? (_openBlock(), _createBlock(BaseLink, {
                    key: 0,
                    to: {
            name: 'chi-tiet-cap-sua-chua',
            params: {
              id: scope.row.cap_sua_chua.id,
            },
          }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.cap_sua_chua.ten_cap_sc || "-"), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, { width: "150" }, {
        header: _withCtx(() => [
          _hoisted_8
        ]),
        default: _withCtx((scope) => [
          _createVNode(BaseLink, {
            to: {
            name: 'chi-tiet-danh-muc-toa-xe',
            params: {
              id: scope.row.id_danh_muc_toa_xe,
            },
          },
            isOpenInNewTab: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.row.danh_muc_toa_xe.ten_danh_muc), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }),
      (__props.showSoLuongVatTu)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            width: "80"
          }, {
            header: _withCtx(() => [
              _hoisted_9
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_10, _toDisplayString(scope.row.vat_tu?.length ?? "-"), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, { width: "140" }, {
        header: _withCtx(() => [
          _hoisted_11
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(formatDisplayingDate)(scope.row.ngay_ban_hanh)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "140" }, {
        header: _withCtx(() => [
          _hoisted_13
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(formatDisplayingDate)(scope.row.ngay_hieu_luc)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { width: "120" }, {
        header: _withCtx(() => [
          _hoisted_15
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_16, [
            (!scope.row.ngay_het_han)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Chưa xác định "))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["fw-bold el-tag el-tag--medium rounded-none d-block w-100", {
                'text-black el-tag--success': !isExpired(
                  scope.row.ngay_het_han
                ),
                'text-danger el-tag--danger': isExpired(scope.row.ngay_het_han),
              }])
                }, _toDisplayString(_unref(formatDisplayingDate)(scope.row.ngay_het_han)), 3))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { "min-width": "300" }, {
        header: _withCtx(() => [
          _hoisted_18
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_19, _toDisplayString(scope.row.mo_ta ?? "-"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        width: "50",
        fixed: "right",
        align: "center"
      }, {
        default: _withCtx((scope) => [
          _createVNode(Setting, {
            actions: getSettingActions(scope.row)
          }, null, 8, ["actions"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})